import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Legal from "../components/Legal"

const LegalPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <Legal />
        </div>
      </main>
    )
}

export default LegalPage